export enum ShipmentResetType {
  StreamingShipmentForBurning,
  CinelinkShipmentForBurning,
  AdebsDriveShipmentForBurning,
  AdebsDriveShipmentForEncryption
}
